import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

/**
 * Generated class for the FormatDatetimePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatHeight',
})
export class FormatHeightPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    // might need to create a more specific format in the admin paneL?

    var res = String(value || '').replace(/"/g, '');
    res = res.replace(/height/g, '');
    return res;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-height/format-height.ts